import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell, getShotId } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS, EXPERIMENT_ORDER } from './experiments';
import { i18n } from './i18n';
import type { ExperimentKey, SetsContext, SetsExperimentDef } from './types';

// `EXPERIMENTS` is typed `Record<string, SetsExperimentDef>` (experiments/index.ts)
// so a partial/scaffold registry typechecks; every key in EXPERIMENT_ORDER is
// actually present, so this narrowing cast is safe.
const REGISTRY = EXPERIMENTS as Readonly<Record<ExperimentKey, SetsExperimentDef>>;

const params = new URLSearchParams(window.location.search);
const seedParam = params.get('seed');
const shotId = getShotId();
const seed = seedParam ? Number(seedParam) : shotId !== null ? 12345 : Date.now() >>> 0;

bootstrapDemoShell({
  slug: 'sets',
  i18n,
  experiments: REGISTRY,
  order: EXPERIMENT_ORDER,
  eyebrowKey: 'app.eyebrow',
  selectorAriaLabelKey: 'app.experiment-selector',
  helpLineKeys: ['app.tagline'],
  shotToExperiment: (id) =>
    (EXPERIMENT_ORDER as readonly string[]).includes(id) ? (id as ExperimentKey) : null,
  extendContext: (base): SetsContext => ({
    ...base,
    prng: makePrng(seed),
  }),
});
